// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2awUc","itemTitle":"ClientEmergencyInfo_itemTitle__2JBKs","itemText":"ClientEmergencyInfo_itemText__2Az8O"};